/* global axios */
import ApiClient from './ApiClient';

class MetaAdsAPI extends ApiClient {
  constructor() {
    super('meta_ads_connections', { accountScoped: true });
  }

  // Returns the Meta OAuth dialog URL to redirect the admin to (fallback flow).
  generateAuthorization() {
    return axios.post(`${this.baseUrl()}/meta_ads/authorization`);
  }

  // Popup flow: exchange the OAuth code from FB.login for connected pages.
  connect(code) {
    return axios.post(this.url, { code });
  }

  adAccounts() {
    return axios.get(`${this.baseUrl()}/meta_ads/ad_accounts`);
  }

  getAudiences() {
    return axios.get(`${this.baseUrl()}/meta_ads/audiences`);
  }

  createAudience(payload) {
    return axios.post(`${this.baseUrl()}/meta_ads/audiences`, payload);
  }

  syncAudience(id) {
    return axios.post(`${this.baseUrl()}/meta_ads/audiences/${id}/sync`);
  }

  deleteAudience(id) {
    return axios.delete(`${this.baseUrl()}/meta_ads/audiences/${id}`);
  }

  insights(adAccountId, datePreset) {
    return axios.get(`${this.baseUrl()}/meta_ads/insights`, {
      params: { ad_account_id: adAccountId, date_preset: datePreset },
    });
  }

  leadEvents() {
    return axios.get(`${this.baseUrl()}/meta_ads/lead_events`);
  }
}

export default new MetaAdsAPI();
